/**
 * Pagination jQuery Plugin
 **/
var Paginator = function(el, options) {
    this.settings = $.extend({}, this.defaults, options);
    this.element = el;
    this.bind();
};
 
Paginator.prototype = {
    // shorthand for using prototype
    constructor : Paginator,
    
    // default options
    defaults : {
        viewableNumbers : 5,
        effect          : 'fade' // fade, slide
    },

    totalItems          : 0,
    totalPages          : 0,

    currentPage         : 0,
    currentSpread       : 0,

    maxPerPage          : 10,

    rowContainer        : null,
    indication          : null,
    element             : null,

    bind : function() {
        var _this = this;
        var e = $(_this.element);
        var _do_it = false;

        if (_this.indication) {
            _this.indication.remove();
            _this.indication = null;
        }

        if (e.is('table') && e.find('tbody').children().length) {
            _this.rowContainer = e.find('tbody');
            _do_it = true;
        } else if ((e.is('ul') || e.is('ol')) && (e.children().length)) {
            _this.rowContainer = e;
            _do_it = true;
        }

        if (_do_it) {
            _this.totalItems = _this.rowContainer.children().length;
            _this.totalPages = Math.ceil(_this.totalItems / _this.maxPerPage);

            if (_this.totalPages > 1) {
                _this.rowContainer.children(':gt(' + (_this.maxPerPage - 1) + ')').hide();
                
                if (!$('.page-indication').length) {
                    var page_indication = '<div class="content-box cf margin-bottom-2x page-indication hide-content">';
                        page_indication +=  '<div class="content">';
                        page_indication +=      '<ul class="ui-pagination">';
                        page_indication +=          '<li class="ui-pagination-item ui-pagination-move inactive page-left" data-page=""><a href="#" class="ui-icon"><</a></li>';
                        page_indication +=          '<li class="ui-pagination-item ui-pagination-move inactive page-right" data-page=""><a href="#" class="ui-icon">></a></li>';
                        page_indication +=      '</ul>';
                        page_indication +=      '<div class="pagination-dropdown float-right">';
                        page_indication +=          '<label>Results Per Page:</label>';
                        page_indication +=          '<select class="ui-select max-per-page">';
                        page_indication +=              '<option>10</option>';
                        page_indication +=              '<option>20</option>';
                        page_indication +=              '<option>50</option>';
                        page_indication +=              '<option>All</option>';
                        page_indication +=          '</select>';
                        page_indication +=      '</div>';
                        page_indication +=  '</div>';
                        page_indication += '</div>';

                    $('body').append(page_indication);
                }

                _this.indication = $('.page-indication').clone();
                _this.indication.removeClass('page-indication');  
                
                e.after(_this.indication);
                _this.renderIndication();
                _this.bindActions();
                _this.checkRender();
            }            
        }
    },

    checkRender : function() {
        if (this.currentPage > (this.totalPages - 1)) {
            if (this.totalPages > 0) {
                this.currentPage = (this.totalPages - 1);
            } else {
                this.currentPage = 0;
            }            
        }  

        this.page(this.currentPage);
    },

    renderIndication : function() {
        var _this = this;

        $('li.page', _this.indication).remove();

        for (var i = 0; i < _this.totalPages; ++i) {
            var _li =  '<li class="ui-pagination-item page '+((i == 0) ? 'active' : '')+'" '+((i > 4) ? 'style="display: none;"' : '')+' data-page="'+i+'"><a class="ui-pagination-link" href="#" data-page="'+i+'">' + (i+1) + '</a></li>';

            $('.page-right', _this.indication).before(_li);
        }    

        $('.ui-pagination-link', _this.indication).on('click', function(e) {
            if (!$(this).parent().hasClass('active')) {
                _this.currentPage = parseInt($(this).attr('data-page'));
                _this.page(_this.currentPage);
            }

            e.preventDefault();
        });

        if (_this.totalPages > 1) {
            $('.page-right', _this.indication).removeClass('inactive').addClass('active');
        }

        if (_this.totalPages > _this.defaults.viewableNumbers) {
            $('.page-right', _this.indication).before('<li class="ui-pagination-item page-more-right"><a href="#"> ... </a></li>');
            $('.page-left', _this.indication).after('<li class="ui-pagination-item page-more-left" style="display:none;"><a href="#"> ... </a></li>');
        }    

        _this.indication.removeClass('hide-content').show();    
    },

    bindActions : function() {
        var _this = this;

        $('.page-left', _this.indication).on('click', function(e) {
            if ($(this).hasClass('active')) {
               _this.pageLeft();
            }

            e.preventDefault();
        });

        $('.page-right', _this.indication).on('click', function(e) {
            if ($(this).hasClass('active')) {
               _this.pageRight();
            }     

            e.preventDefault();              
        });

        $('.page-more-right a', _this.indication).on('click', function(e) {
           _this.spreadRight();
            e.preventDefault();
        });

        $('.page-more-left a', _this.indication).on('click', function(e) {
           _this.spreadLeft();
            e.preventDefault();
        });

        if ($('.max-per-page', _this.indication).length) {
            $('.max-per-page', _this.indication).on('change', function() {
                if ($(this).val() == "All") {
                    _this.maxPerPage = _this.totalItems;
                } else {
                    _this.maxPerPage = parseInt($(this).val());
                }

                _this.totalPages = Math.ceil(_this.totalItems / _this.maxPerPage);

                $('li.page', _this.indication).remove();

                for (var i = 0; i < _this.totalPages; ++i) {
                    var _li =  '<li class="ui-pagination-item page '+((i == 0) ? 'active' : '')+'" '+((i > 4) ? 'style="display: none;"' : '')+' data-page="'+i+'"><a class="ui-pagination-link" href="#" data-page="'+i+'">' + (i+1) + '</a></li>';

                    $('.page-right', _this.indication).before(_li);
                }  

                _this.renderIndication();
                _this.checkRender();
                _this.page(_this.currentPage);
                _this.updatePageNumbers(true);                        
            });
        }
    },

    pageLeft : function() {
        if (this.currentPage > 0) {
            this.currentPage -= 1;
            this.page(this.currentPage);
            this.updatePageNumbers(false);
        }
    },

    pageRight : function() {
        if (this.currentPage < this.totalPages) {
            this.currentPage += 1;
            this.page(this.currentPage);
            this.updatePageNumbers(false);
        }
    },

    spreadRight : function() {
        var _this = this;
        ++_this.currentSpread;
        _this.updatePageNumbers(true);
    },

    spreadLeft : function() {
        var _this = this;
         --_this.currentSpread;
        _this.updatePageNumbers(true);
    },

    updatePageNumbers : function(spread) {
        var _this = this;
        var viewable = _this.defaults.viewableNumbers;

        var firstPage = _this.currentSpread * viewable,
            lastPage = (_this.currentSpread * viewable) + viewable - 1,
            newStart = 0,
            reRender = false;

        if (spread) {
            reRender = true;
            newStart = _this.currentSpread * viewable;
        } else if ((this.currentPage > lastPage) || (this.currentPage < firstPage)) {
            reRender = true;

            if ((_this.currentPage > lastPage) || (_this.currentPage < firstPage)) {
                if (_this.currentPage > lastPage) {
                    ++_this.currentSpread;
                } else if (_this.currentPage < firstPage) {
                    --_this.currentSpread;
                }   

                newStart = _this.currentSpread * viewable;
                firstPage = newStart;
                lastPage = newStart + viewable - 1;     
            }
        }

        if (reRender) {
            $('.page', _this.indication).hide();
            $('.page', _this.indication).slice(newStart, newStart+viewable).fadeIn();
           
            if (_this.totalPages > (firstPage+viewable)) {
                $('.page-more-right', _this.indication).show();     
            } else {
                $('.page-more-right', _this.indication).hide();   
            }

            if (firstPage > 0) {
                $('.page-more-left', _this.indication).show();     
            } else {
                $('.page-more-left', _this.indication).hide();   
            } 
        }
    },

    page : function(newPage) {
        var _this = this;
        var first = parseInt(newPage) * _this.maxPerPage;
        var last = first + _this.maxPerPage;
        $('.page', _this.indication).removeClass('active');
        $('.page[data-page="'+_this.currentPage+'"]', _this.indication).addClass('active');

        if (_this.rowContainer && _this.rowContainer.children().length) {
            _this.rowContainer.children().not('.group-edit-row').hide();
            _this.rowContainer.children().slice(first, last).fadeIn('fast');
        }

        if (_this.indication) {
            if (_this.currentPage == 0) {
                _this.indication.find('.page-left').removeClass('active').addClass('inactive');

                if (_this.totalPages > 1) {
                    _this.indication.find('.page-right').removeClass('inactive').addClass('active');
                } else {
                    _this.indication.find('.page-right').removeClass('active').addClass('inactive');
                }
            } else if (_this.currentPage == (_this.totalPages - 1)) {
                _this.indication.find('.page-right').removeClass('active').addClass('inactive');
                _this.indication.find('.page-left').removeClass('inactive').addClass('active');
            } else {
                _this.indication.find('.page-right').removeClass('inactive').addClass('active');
                _this.indication.find('.page-left').removeClass('inactive').addClass('active');
            }
        }
    }
};

$.fn.paginate = function ( options ) {
    return this.each(function () {
        if (!$.data(this, 'qg_pagination')) {
            $.data(this, 'qg_pagination', new Paginator( this, options ));
        } 
    });
};